module.exports = __webpack_public_path__ + "static/prada-081907d7e60532aea66c058f53484d18.png";